import React, { ComponentType } from 'react'
import { useNavigate } from 'react-router-dom'

export interface WithRedirectProps {
    setRedirect: (path: string) => void
}

/**
 * Higher-order component injecting a `setRedirect` prop that navigates
 * to the given path using React Router 7's `useNavigate` hook.
 *
 * Replaces the legacy implementation built around RR5's `Redirect`
 * component and local state.
 */
const withRedirect = <TProps extends WithRedirectProps>(
    OriginalComponent: ComponentType<TProps>,
): ComponentType<Omit<TProps, 'setRedirect'>> => {
    const UpdatedComponent = (props: Omit<TProps, 'setRedirect'>) => {
        const navigate = useNavigate()

        const setRedirect = (path: string): void => {
            navigate(path)
        }

        return <OriginalComponent {...(props as TProps)} setRedirect={setRedirect} />
    }

    return UpdatedComponent
}

export default withRedirect
